import React, { useRef, useContext, useState, useEffect } from "react";
import AppContext from "../context/store";

import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import {
  WhatsApp,
  Message,
} from "@material-ui/icons";

function ChatBox() {
  const context = useContext(AppContext);
  const tawkMessengerRef = useRef();
  const [whatsAppMessage, setWhatsAppMessage] = useState("");

  useEffect(() => {
    setWhatsAppMessage(
      `https://api.whatsapp.com/send?phone=902129634644&text=Merhabalar,%20size%20web%20paneliniz%20üzerinden%20ulaşıyorum.%20Proje:%20${process.env.APP_NAME === "salon" ? "Salon Randevu" : process.env.APP_NAME === "en" ? "En Randevu" : "Salon Management"}%20-%20Üye%20ID:%20${context.state.company_license.company_id}%20-%20Kayıtlı%20kişi:%20${context.state.user.full_name}`
    );
    console.log(context);
  }, []);

  const onLoad = () => {
    if (tawkMessengerRef.current) {
      tawkMessengerRef.current.setAttributes({
        name: `${context.state.user.full_name}-${context.state.company_license.company_id}`,
      });
    }
  };

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "25px", display: "flex", flexDirection: "column", gap: "10px", zIndex: 9999 }}>
      <a
        href={whatsAppMessage}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          backgroundColor: "#25D366",
          color: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          textDecoration: "none",
        }}
      >
        <WhatsApp fontSize="large" />
      </a>

      <a
        href="javascript:void(Tawk_API.toggle())"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          backgroundColor: "#3F70EE",
          color: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          textDecoration: "none",
        }}
      >
        <Message fontSize="large" />
        <TawkMessengerReact
          propertyId="5eb2d120a1bad90e54a240b4"
          widgetId="default"
          onLoad={onLoad}
          ref={tawkMessengerRef}
        />
      </a>
    </div>
  );
}

export default ChatBox;
